"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEASING_CONTACT_EMAIL = void 0;
exports.LEASING_CONTACT_EMAIL = 'leasing@upandup.co';
